/* istanbul ignore file */

import { useInterpret, useSelector } from '@xstate/react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { otaUpdateStateMachine } from './ota-update-state-machine';

// ─────────────────────────────────────────────────────────────────────────────

export const useOtaUpdateMachine = () => {
  //
  // ─── Feature Flags ───────────────────────────────────────────────────

  const initialUpdateEventTimeout = useFeatureFlag(
    'OTA-update-in-app-checker-initial-check-timeout-ms',
  );
  const pollingInterval = useFeatureFlag(
    'OTA-update-in-app-checker-polling-interval-ms',
  );

  // ─── Machine ─────────────────────────────────────────────────────────

  const otaUpdateService = useInterpret(otaUpdateStateMachine, {
    context: {
      options: { initialUpdateEventTimeout, pollingInterval },
    },
  });

  const { send } = otaUpdateService;

  // ─── Derived Data ────────────────────────────────────────────────────

  const availableUpdate = useSelector(
    otaUpdateService,
    (state) => state.context.availableUpdate,
  );

  // ─── Flags ───────────────────────────────────────────────────────────

  const updateState = useSelector(otaUpdateService, (state) => {
    const { matches } = state;

    return {
      isRestartingApp: matches('pendingUpdate.restarting'),
      hasFailedToRestartApp: matches('pendingUpdate.restartingFailed'),
      hasPendingUpdate:
        matches('pendingUpdate') && !matches('pendingUpdate.idle'),
      hasPendingRegularUpdate: matches('pendingUpdate.regularUpdate'),
      hasPendingCriticalUpdate: matches('pendingUpdate.criticalUpdate'),
    };
  });

  // ─────────────────────────────────────────────────────────────────────

  return { availableUpdate, updateState, send };
};
